import { mixed, object, string } from 'yup';

import { US_STATE_OPTIONS } from '../../../../../../constants';
import {
  MEDICAL_DIAGNOSIS_CITY_MIN_LENGTH,
  MEDICAL_DIAGNOSIS_OPTIONS,
  MEDICAL_DIAGNOSIS_PROVIDER_MIN_LENGTH,
  MEDICAL_DIAGNOSIS_TEXT_MAX_LENGTH,
  MEDICAL_DIAGNOSIS_YEAR_MAX,
  MEDICAL_DIAGNOSIS_YEAR_MIN,
} from './constants';
import { isMedicalDiagnosisYearValid } from './utils';

import type { Moment } from 'moment';

export const MEDICAL_DIAGNOSIS_SCHEMA = object({
  diagnosis_name: string().oneOf(MEDICAL_DIAGNOSIS_OPTIONS).required('Required'),
  provider_name: string()
    .trim()
    .min(MEDICAL_DIAGNOSIS_PROVIDER_MIN_LENGTH)
    .max(MEDICAL_DIAGNOSIS_TEXT_MAX_LENGTH)
    .required('Required'),
  city: string()
    .trim()
    .min(MEDICAL_DIAGNOSIS_CITY_MIN_LENGTH)
    .max(MEDICAL_DIAGNOSIS_TEXT_MAX_LENGTH)
    .required('Required'),
  state: string()
    .oneOf(US_STATE_OPTIONS.map((option) => option.value))
    .required('Required'),
  year: mixed<Moment>()
    .nullable()
    .test(
      'valid-year',
      `Enter a year from ${MEDICAL_DIAGNOSIS_YEAR_MIN} to ${MEDICAL_DIAGNOSIS_YEAR_MAX}`,
      (value) => value != null && value.isValid() && isMedicalDiagnosisYearValid(value.year()),
    )
    .required('Required'),
});
